import { DropdownMenuItem } from '@/components/ui/dropdown-menu'
import Icon from '@/components/ui/icon'
import { User } from '@/types/user'

interface CreateTenantDropdownItemPropsProps {
  user: User
  handleCreateClick: () => void
}

export default function CreateTenantDropdownItemProps({ user, handleCreateClick }: CreateTenantDropdownItemPropsProps) {
  const isUserAllowedToCreateTenant =
    (user?.typeCargo === 'CEO' || user?.typeCargo === 'TI') && user?.typeUser === 'ADMIN'
  if (!isUserAllowedToCreateTenant) {
    return null
  }

  return (
    <>
      <DropdownMenuItem
        className="gap-2 p-2 cursor-pointer"
        onClick={handleCreateClick}
        onSelect={e => e.preventDefault()}
      >
        <div className="flex size-6 items-center justify-center rounded-md border bg-background">
          <Icon name="Plus" className="size-4" />
        </div>
        <div className="font-medium text-muted-foreground">Adicionar Empresa</div>
      </DropdownMenuItem>
    </>
  )
}
